import axios from './categoryInstance';
import { getCompanyId } from '@/utils/getCompanyId'

export default async function (image: string) {
  const companyId = getCompanyId()
  const payload = {
    url: image,
    company_id: companyId,
  }

  const response: any = await axios.post(`/images/`, payload)
  return response.data?.data?.id ?? response.data?.id
}
